// Genesis Appliance Repair — global business data

export const SITE = {
  brand: "Genesis",
  brandFull: "Genesis Appliance Repair",
  phone: "(808) 764-4304",
  phoneHref: "tel:+18087644304",
  email: "service@genesisappliancerepair.com",
  region: "Big Island of Hawaii",
  serviceAreas: [
    "Holualoa, HI",
    "Kealakekua, HI",
    "Ocean View, HI",
    "Kailua-Kona, HI",
    "Captain Cook, HI",
    "Waimea, HI",
  ],
  brands: [
    "GE",
    "Samsung",
    "Whirlpool",
    "Amana",
    "Electrolux",
    "Maytag",
    "Bosch",
    "LG",
  ],
  hours: [
    { dayKey: "monFri", time: "8:00 AM to 6:00 PM" },
    { dayKey: "sat", time: "8:00 AM to 2:00 PM" },
    { dayKey: "sun", time: "closedOnlineOnly" },
  ],
  social: {
    facebook: "https://www.facebook.com/genesisappliance/",
    linkedin: "https://www.linkedin.com/company/genesis-appliance-repair-llc/",
    twitter: "https://x.com/Genesisapprep",
    tiktok: "https://www.tiktok.com/@genesisppliancerepair?lang=en",
    youtube: "https://www.youtube.com/@GenesisApplianceRepair",
  },
};

export const NAV = [
  { to: "/", labelKey: "nav.home" },
  { to: "/about", labelKey: "nav.about" },
  { to: "/services", labelKey: "nav.services" },
  { to: "/blog", labelKey: "nav.blog" },
  { to: "/contact", labelKey: "nav.contact" },
];

export const SERVICES = [
  {
    slug: "washer",
    to: "/services/washer",
    key: "washer",
    image:
      "https://images.unsplash.com/photo-1626806787461-102c1bfaaea1?auto=format&fit=crop&w=1600&q=80",
  },
  {
    slug: "dryers",
    to: "/services/dryers",
    key: "dryer",
    image:
      "https://customer-assets.emergentagent.com/job_aloha-repair-hub/artifacts/158hj52s_dryer%20repair.jpg",
  },
  {
    slug: "refrigerator",
    to: "/services/refrigerator",
    key: "refrigerator",
    image:
      "https://customer-assets.emergentagent.com/job_aloha-repair-hub/artifacts/cd8szcf9_refrigerator%20repair%20image.webp",
  },
  {
    slug: "dishwasher",
    to: "/services/dishwasher",
    key: "dishwasher",
    image:
      "https://images.unsplash.com/photo-1581622558663-b2e33377dfb2?auto=format&fit=crop&w=1600&q=80",
  },
  {
    slug: "range-oven",
    to: "/services/range-oven",
    key: "rangeOven",
    image:
      "https://customer-assets.emergentagent.com/job_aloha-repair-hub/artifacts/2d4qce15_range%20and%20oven%20repair.jfif",
  },
];

export const MEDIA = {
  hero: "https://customer-assets.emergentagent.com/job_aloha-repair-hub/artifacts/r3d06etl_Fixing%20wahser.png",
  heroAlt:
    "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1800&q=85",
  about:
    "https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?auto=format&fit=crop&w=1600&q=85",
  technician:
    "https://images.unsplash.com/photo-1581094794329-c8112a89af12?auto=format&fit=crop&w=1600&q=85",
  hawaii:
    "https://images.unsplash.com/photo-1542209025-7b97cd6f7045?auto=format&fit=crop&w=1600&q=85",
  kitchen:
    "https://images.unsplash.com/photo-1556909190-eccf4a8bf97a?auto=format&fit=crop&w=1600&q=85",
  workshop:
    "https://images.unsplash.com/photo-1607472586893-edb57bdc0e39?auto=format&fit=crop&w=1600&q=85",
};
